import React, {
    useState,
    useCallback,
} from 'react';
import styled from 'styled-components';
import Recaptcha from 'react-grecaptcha';
import actionCreators from 'actions/creators';
import GLOBAL from 'nonnglobal';
import { GlobalStyle, Colors } from 'stylecomponents';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import CupoyRouter from 'components/commons/router/CupoyRouter';
import CupoySrefView from 'components/commons/router/CupoySrefView';

/**
 * Styled
 */
const Header = styled.section`
    padding: 40px 40px 20px;
    border-bottom: 1px solid #CCCCCC;
`;
const Title = styled.h3`
    margin: 0 0 14px 0;
    font-size: 22px;
    font-weight: 600;
`;
const Paragraph = styled.p`
    width: 73%;
    font-size: 14px;
    color: #4A4A4A;
    text-align: justify;
    line-height: 22px;
    margin: 0;
`;
const Content = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    padding: 30px;
    border-bottom: 1px solid #CCC;
`;
const FormWrapper = styled.div`
    display: grid;
    grid-gap: 30px;
`;
const InputItem = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    color: #232423;
    font-size: 15px;
`;
const Input = GlobalStyle.BasicInput.extend`
    margin-left: 16px;
    width: ${({ width }) => width ? `${width}px` : '415px'};

    ${({ error }) => {
        if(error) {
            return `
                border: 1px solid ${Colors.Red};
                color: ${Colors.Red};
            `;
        }
    }}
`;
const RecaptchaWrapper = styled.div`
    margin-left: 80px;
`;
const RecaptchaTitle = styled.div`
    margin-bottom: 10px;
    color: #232423;
`;
const Submit = styled.div`
    width: 100%;
    padding: 30px 0;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
`;
const SubmitBtn = styled.div`
    position: relative;
    margin-right: 16px;
    width: 200px;
    height: 44px;
    line-height: 44px;
    text-align: center;
    color: #FFF;
    font-size: 16px;
    border-radius: 2px;
    background-color: ${Colors.MAIN_COLOR};
    cursor: pointer;
    user-select: none;

    > ${GlobalStyle.Spin} {
        margin-right: 10px;
    }
`;

/**
 * 會員載具歸戶 - 大平台
 * @author Ac
 * @time 2020 / 08 / 18
 */
const MemberCarrierPlatformView = props => {

    const { token } = props.match.params;

    const [isLoading, setIsLoading] = useState(false);
    const [memberId, setMemberId] = useState('');
    const [password, setPassword] = useState('');
    const [recaptchaResponse, setRecaptchaResponse] = useState('');

    const handleMemberId = event => {
        setMemberId(event.target.value);
    };
    const handlePassword = event => {
        setPassword(event.target.value);
    };

    const handleRecaptchaResponse = useCallback(
        response =>  {
            setRecaptchaResponse(response);
        },
        []
    );

    const expiredCallback = useCallback(
        () => {
            setRecaptchaResponse('');
            props.webActions.openAlertDialog({
                title: '安全認證已過期',
            });
        },
        [props.webActions]
    );

    const confirmMemberCarrier = () => {

        if (isLoading) {
            return;
        }

        if(GLOBAL.isEmpty(memberId) || GLOBAL.isEmpty(password)){
            props.webActions.openAlertDialog({
                title: '錯誤訊息',
                description : '請輸入帳號或密碼',
                closeName: '關閉',
            });
            return;
        }

        if(GLOBAL.isEmpty(recaptchaResponse)){
            props.webActions.openAlertDialog({
                title: '錯誤訊息',
                description : '請勾選『我不是機器人』',
                closeName: '關閉',
            });
            return;
        }

        setIsLoading(true);

        props.memberActions.confirmMemberCarrier({
            token,
            memberId,
            password,
            passcode: recaptchaResponse,
        }).catch(error => {

            setIsLoading(false);
            setRecaptchaResponse('');

            window.grecaptcha.reset();

            let errorMsg = '系統發生無法預期的錯誤';

            if(error && error.code) {
                switch(error.code) {
                    case 'error.account.accountNotExist':
                        errorMsg = '此帳號不存在';
                        break;
                    case 'error.account.isFreeze':
                        return props.webActions.openAlertDialog({
                            title: '錯誤訊息',
                            renderDescription: closeDialog => (
                                <React.Fragment>
                                    <span>會員停權中，請洽客服人員。</span><br/>
                                    <CupoySrefView
                                        statename={CupoyRouter.STATES.NEWS_CONTENT}
                                        params={{
                                            id: '1590395459418',
                                        }}
                                        onClick={closeDialog}
                                    >
                                        查看停權原因！
                                    </CupoySrefView>
                                </React.Fragment>
                            ),
                            closeName: '確定',
                        });
                    case 'error.formValidator.passwordFailed':
                        errorMsg = '密碼錯誤，請重新操作。';
                        break;
                    case 'error.formValidator.antiPassCodeFailed':
                        errorMsg = '安全性驗證錯誤';
                        break;
                    default:
                        errorMsg = error.message;
                        break;
                }
            }

            props.webActions.openAlertDialog({
                title: '錯誤訊息',
                description : errorMsg,
                closeName: '確定',
            });
        });
    };

    return (
        <GlobalStyle.SubContainer>
            <GlobalStyle.BasicBlock>

                <Header>
                    <Title>電子發票歸戶</Title>
                    <Paragraph>
                        系統收到您於「財政部電子發票整合服務平台」進行歸戶設定功能，請輸入您的帳號及密碼進行會員載具歸戶。
                    </Paragraph>
                </Header>

                <Content>
                    <FormWrapper>
                        <InputItem>
                            帳號
                            <Input
                                type='text'
                                value={memberId}
                                placeholder='請輸入帳號'
                                onChange={handleMemberId}
                            />
                        </InputItem>
                        <InputItem>
                            密碼
                            <Input
                                type='password'
                                value={password}
                                placeholder='請輸入密碼'
                                onChange={handlePassword}
                            />
                        </InputItem>
                    </FormWrapper>
                    <RecaptchaWrapper>
                        <RecaptchaTitle>安全性驗證</RecaptchaTitle>
                        <Recaptcha
                            sitekey={GLOBAL.grecaptcha_key}
                            callback={handleRecaptchaResponse}
                            expiredCallback={expiredCallback}
                            locale='zh-TW'
                            className='g-recaptcha'
                            style={{
                                transformOrigin: '0 0',
                                WebkitTransformOrigin: '0 0',
                            }}
                        />
                    </RecaptchaWrapper>
                </Content>
                
                <Submit>
                    <SubmitBtn onClick={confirmMemberCarrier}>
                        {isLoading && (
                            <GlobalStyle.Spin color='#fff'/>
                        )}
                        確認送出
                    </SubmitBtn>
                </Submit>
            </GlobalStyle.BasicBlock>
        </GlobalStyle.SubContainer>
    );
};

/*--------------------------
    Reducer Action
--------------------------*/
const mapActionToProps = function(dispatch) {
    return {
        webActions: bindActionCreators(actionCreators.webActionCreators, dispatch),
        memberActions: bindActionCreators(actionCreators.memberActionCreators, dispatch),
    };
};

/*--------------------------
    export
--------------------------*/
export default connect(null, mapActionToProps)(MemberCarrierPlatformView);